'use client';

import React from 'react';
import Link from 'next/link';
import { Clock, Users, Trophy, ArrowRight } from 'lucide-react';

const activities = [
  {
    id: 'rec-1',
    title: 'Advanced JavaScript Coding Challenge',
    category: 'Coding',
    profession: 'Developer',
    entry: '$5',
    prize: '$350',
    participants: 84,
    maxParticipants: 100,
    timeLeft: '4h 20m',
    difficulty: 'Advanced',
    badge: 'paid',
    badgeColor: '#F59E0B',
    emoji: '💻',
    matchScore: 98,
  },
  {
    id: 'rec-2',
    title: 'India GK Trivia — Daily Edition',
    category: 'Knowledge',
    profession: 'All Professions',
    entry: 'Free',
    prize: '500 XP',
    participants: 1204,
    maxParticipants: 2000,
    timeLeft: '1h 45m',
    difficulty: 'Beginner',
    badge: 'free',
    badgeColor: '#10B981',
    emoji: '🧠',
    matchScore: 94,
  },
  {
    id: 'rec-3',
    title: 'UI/UX Design Sprint — Mobile App',
    category: 'Creative',
    profession: 'Designer',
    entry: '$10',
    prize: '$1,200',
    participants: 34,
    maxParticipants: 50,
    timeLeft: '2d 6h',
    difficulty: 'Intermediate',
    badge: 'paid',
    badgeColor: '#F59E0B',
    emoji: '🎨',
    matchScore: 91,
  },
  {
    id: 'rec-4',
    title: 'Speed Math Championship',
    category: 'Mathematics',
    profession: 'Students',
    entry: 'Free',
    prize: '₹2,000 + Badge',
    participants: 892,
    maxParticipants: 1000,
    timeLeft: '6h 10m',
    difficulty: 'Intermediate',
    badge: 'free',
    badgeColor: '#10B981',
    emoji: '🔢',
    matchScore: 88,
  },
  {
    id: 'rec-5',
    title: 'Content Marketing Strategy Challenge',
    category: 'Marketing',
    profession: 'Marketer',
    entry: '$8',
    prize: '$600',
    participants: 67,
    maxParticipants: 100,
    timeLeft: '3d 2h',
    difficulty: 'Intermediate',
    badge: 'paid',
    badgeColor: '#F59E0B',
    emoji: '📊',
    matchScore: 85,
  },
  {
    id: 'rec-6',
    title: 'Word Builder — Daily Puzzle',
    category: 'Games',
    profession: 'All Professions',
    entry: 'Free',
    prize: '200 XP',
    participants: 4821,
    maxParticipants: 10000,
    timeLeft: '18h',
    difficulty: 'Beginner',
    badge: 'free',
    badgeColor: '#10B981',
    emoji: '🔤',
    matchScore: 82,
  },
];

export default function RecommendedActivities() {
  return (
    <div className="rounded-xl p-5" style={{ background: 'var(--card)', border: '1px solid var(--border)' }}>
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="text-base font-bold text-foreground">Recommended for You</h3>
          <p className="text-xs mt-0.5" style={{ color: 'var(--muted-foreground)' }}>Based on your profession (Developer) and interests</p>
        </div>
        <Link href="/discover-screen" className="flex items-center gap-1 text-xs font-semibold" style={{ color: '#A78BFA' }}>
          View all <ArrowRight size={12} />
        </Link>
      </div>

      <div className="space-y-3">
        {activities.map((activity) => (
          <Link href="/activity-detail-page" key={activity.id}
            className="flex items-center gap-4 p-3 rounded-xl transition-all hover:bg-muted/50 group"
            style={{ border: '1px solid transparent' }}
            onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.borderColor = 'rgba(124,58,237,0.2)'; }}
            onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.borderColor = 'transparent'; }}
          >
            {/* Emoji icon */}
            <div className="w-10 h-10 rounded-xl flex items-center justify-center text-xl flex-shrink-0"
              style={{ background: 'var(--muted)' }}>
              {activity.emoji}
            </div>

            {/* Info */}
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-0.5">
                <p className="text-sm font-semibold text-foreground truncate">{activity.title}</p>
                <span className="text-xs px-1.5 py-0.5 rounded-full flex-shrink-0"
                  style={{ background: `${activity.badgeColor}20`, color: activity.badgeColor, fontSize: '10px', fontWeight: 600 }}>
                  {activity.badge === 'free' ? 'FREE' : activity.entry}
                </span>
              </div>
              <div className="flex items-center gap-3 text-xs" style={{ color: 'var(--muted-foreground)' }}>
                <span>{activity.category}</span>
                <span className="flex items-center gap-1"><Users size={10} />{activity.participants.toLocaleString()}</span>
                <span className="flex items-center gap-1"><Clock size={10} />{activity.timeLeft}</span>
                <span className="flex items-center gap-1"><Trophy size={10} />{activity.prize}</span>
              </div>
            </div>

            {/* Match score */}
            <div className="flex-shrink-0 text-right">
              <div className="text-xs font-bold mb-0.5" style={{ color: '#10B981' }}>{activity.matchScore}% match</div>
              <div className="text-xs px-2 py-0.5 rounded-full" style={{ background: 'rgba(124,58,237,0.15)', color: '#A78BFA' }}>
                Join
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}